export default __webpack_public_path__ + "static/media/home_explain_analytics@3x.98be8b02.png";